import { LocalizationString } from '@celito.clients/assets';
import { InHouseInputSelect, RulesComponent } from '@celito.clients/shared';
import { returnSelectedOptionFromOptions } from 'apps/web-client/src/screens/Platform/admin-ui-screen/utils/utils';
import { RuleComponentEnum } from 'libs/shared/src/lib/rules-component/types/rules-component.types';
import { Controller, useFormContext } from 'react-hook-form';

import { ComponentActionsProps } from './component-actions.model';
import { ComponentActionsStyles } from './component-actions.styles';

interface ComponentActionsViewProps extends ComponentActionsProps {
  onSelectTabFunction: (selectedTab: string) => void;
  selectedTab: number;
  onRemoveEntryAction: (index: number) => void;
  onAddEntryAction: () => void;
}

export const ComponentActionsView = ({
  onSelectTabFunction,
  selectedTab,
  objectOptions,
  formPath,
  IsLoadingActionData,
  actionsOptions,
  hideActions = false,
  isSingleLayout = false,
  allowDeleteAllGroups = true,
  onAddEntryAction,
  onRemoveEntryAction,
}: ComponentActionsViewProps) => {
  const styles = ComponentActionsStyles();

  const methods = useFormContext();

  const { control, setValue, getValues } = methods;

  return (
    <div className={styles.formContainer}>
      <RulesComponent
        methods={methods}
        fields={objectOptions}
        onAddRule={onAddEntryAction}
        onRemoveRule={onRemoveEntryAction}
        ruleLayout={
          isSingleLayout
            ? RuleComponentEnum.SingleRule
            : RuleComponentEnum.MultipleRules
        }
        multiRulesPlaceholder={'Insert name'}
        isMultiRuleLabelDisabled={true}
        allowDeleteAllGroups={allowDeleteAllGroups}
        onSelectTabFunction={onSelectTabFunction}
        interfaceName={formPath}
        isCompact
      />
      {!hideActions && (
        <div className={styles.thenContainer}>
          <div className={styles.thenInnerContainer}>
            <Controller
              control={control}
              name={`${formPath}.${selectedTab}.action.name`}
              rules={{ required: true }}
              render={({ field, fieldState: { error } }) => (
                <InHouseInputSelect
                  label={LocalizationString.ACTIONS}
                  options={actionsOptions ?? []}
                  isLoadingOptions={IsLoadingActionData}
                  selectedOptions={returnSelectedOptionFromOptions(
                    actionsOptions,
                    getValues(`${formPath}.${selectedTab}.action.name`)
                  )}
                  onOptionSelect={(_ev, data) => {
                    if (Array.isArray(data.selectedOptions)) {
                      const selectedOpt = data.selectedOptions.map(
                        (selected) => selected.value
                      );

                      setValue(
                        `${formPath}.${selectedTab}.action.name`,
                        selectedOpt,
                        { shouldValidate: true, shouldDirty: true }
                      );
                    }
                  }}
                  multiselect
                  errorMessage={
                    error ? LocalizationString.FIELD_IS_REQUIRED : undefined
                  }
                />
              )}
            />
          </div>
        </div>
      )}
    </div>
  );
};
